import React from 'react';

// 23) Next we want to hook up our navigation links in the header to our routes. They are currently written with <a> tags. We are going to change this. We will use the react-router 'Link' component. First we will import the component ...

// import { Link } from 'react-router-dom';

// 27) If we want to add an active class to all links with routes that are currently active (an active route matches the current url in the address bar). Then change Link to NavLInk ...

import { NavLink } from 'react-router-dom';


// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li><a href="#">Home</a></li>
//       <li><a href="#">About</a></li>
//       <li><a href="#">Teachers</a></li>
//       <li><a href="#">Courses</a></li>
//     </ul>
//   </header>
// );

// 24) Now we change our <a> tags to <link> tags ...

// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li>Link href="#">Home</Link></li>
//       <li>Link href="#">About</Link></li>
//       <li>Link href="#">Teachers</Link></li>
//       <li>Link href="#">Courses</Link></li>
//     </ul>
//   </header>
// );

// 25) And we change our 'href' attributes to 'to' attributes ...

// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li><link to="#">Home</link></li>
//       <li><link to="#">About</link></li>
//       <li><link to="#">Teachers</link></li>
//       <li><link to="#">Courses</link></li>
//     </ul>
//   </header>
// );

// 26) Now we need to match our 'to' attribute values to our routes ...

// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li><Link to="/">Home</Link></li>
//       <li><Link to="/about">About</Link></li>
//       <li><Link to="/teachers">Teachers</Link></li>
//       <li><Link to="/courses">Courses</Link></li>
//     </ul>
//   </header>
// );

// 28) Then change the Link tags to NavLink tags. Now all active links have the class of active and are styled with the blue background color ...

// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li><NavLink to="/">Home</NavLink></li>
//       <li><NavLink to="/about">About</NavLink></li>
//       <li><NavLink to="/teachers">Teachers</NavLink></li>
//       <li><NavLink to="/courses">Courses</NavLink></li>
//     </ul>
//   </header>
// );

// 29) Again we have the same problem with the home link being recocognized as active on all route paths (when any of the active links begins with '/'). Again we need to add the 'exact' attribut to the 'Home' NavbLink tag ...

// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li><NavLink exact to="/">Home</NavLink></li>
//       <li><NavLink to="/about">About</NavLink></li>
//       <li><NavLink to="/teachers">Teachers</NavLink></li>
//       <li><NavLink to="/courses">Courses</NavLink></li>
//     </ul>
//   </header>
// );

// 30) The NavLink component also let's you assign a custom class name to an active link (This becomes the default active call name and replaced the current active class name).
// const Header = () => (
//   <header>
//     <span className="icn-logo"><i className="material-icons">code</i></span>
//     <ul className="main-nav">
//       <li><NavLink exact to="/">Home</NavLink></li>
//       <li><NavLink to="/about" activeClassName="actyMcActiveFace">About</NavLink></li>
//       <li><NavLink to="/teachers">Teachers</NavLink></li>
//       <li><NavLink to="/courses">Courses</NavLink></li>
//     </ul>
//   </header>
// );

// 31) And you are able to define active styles inline with the activeStyle attribute. So now just the home link has a red background when active ...

// 32) Now we are going to hook up the subnavigation in the courses tab. So let's go to ((Courses.js))

const Header = () => (
  <header>
    <span className="icn-logo"><i className="material-icons">code</i></span>
    <ul className="main-nav">
      <li><NavLink exact to="/" activeStyle={{ background: 'red' }}>Home</NavLink></li>
      <li><NavLink to="/about" activeClassName="actyMcActiveFace">About</NavLink></li>
      <li><NavLink to="/teachers">Teachers</NavLink></li>
      <li><NavLink to="/courses">Courses</NavLink></li>
    </ul>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js